const { helpers } = require("vuelidate/lib/validators");

const length = length =>
  helpers.withParams(
    { type: "length" },
    value => !helpers.req(value) || helpers.len(value) === length
  );

module.exports = length;
